const usePermissionConfig = () => {
  return {
    /*
    * 新增
    * 控制：新增
    * 跳转路由名称：
    * */
    CREATE: 'OPS-XTPZ-CKGL-XZ',
    /*
    * 修改
    * 控制：修改
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-XTPZ-CKGL-XG',
    /*
    * 删除
    * 控制：删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-XTPZ-CKGL-SC',
  };
};

export default usePermissionConfig;
